import * as React from "react";

import ModalBase from "./ModalBase";
import { useModal } from "../context/ModalContext";

interface ConfirmModalProps {
  message: string | React.ReactNode;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  message,
  onConfirm,
  onCancel,
}) => {
  const { hideModal } = useModal();

  const handleConfirm = () => {
    onConfirm();
    hideModal();
  };

  const handleCancel = () => {
    onCancel();
    hideModal();
  };

  return (
    <ModalBase
      header="Confirm"
      body={message}
      footer={
        <>
          <button className="loa-button" onClick={handleCancel}>
            Cancel
          </button>
          <button
            className="loa-button loa-button-primary"
            onClick={handleConfirm}
          >
            Confirm
          </button>
        </>
      }
    />
  );
};

export default ConfirmModal;
